import { render, staticRenderFns } from "./Boton2HistorialEstadosAcademicos.vue?vue&type=template&id=6f483e10"
import script from "./Boton2HistorialEstadosAcademicos.vue?vue&type=script&lang=js"
export * from "./Boton2HistorialEstadosAcademicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports